"use client";

import dataProviderSimpleRest from "@refinedev/simple-rest";
import axios from "axios";
import { installAuthGuard } from "./authGuard";

export const API_URL = process.env.NEXT_PUBLIC_API_URL || "http://localhost:3200/api";

// Axios instance with the auth-token guard installed: it attaches the access token,
// proactively refreshes it when expired, and on a 401 pings/refreshes/retries before
// letting the request fail (which logs the user out). See authGuard.ts / httpClient.ts.
const axiosInstance = axios.create();
installAuthGuard(axiosInstance);

export const restapidataProvider = dataProviderSimpleRest(API_URL, axiosInstance);
